__turbopack_context__.v({
  "cardImage": "ProgramsCarousel-module__MdJY7a__cardImage",
  "cardItem": "ProgramsCarousel-module__MdJY7a__cardItem",
  "cardLogo": "ProgramsCarousel-module__MdJY7a__cardLogo",
  "frame": "ProgramsCarousel-module__MdJY7a__frame",
  "scroll": "ProgramsCarousel-module__MdJY7a__scroll",
  "track": "ProgramsCarousel-module__MdJY7a__track",
});
